import "./NotFoundPage.css";

const NotFoundPage = (props) => {
  return (
    <div>
      <h1 className="header-xl">Hey something went wrong btw.</h1>
    </div>
  );
};

export default NotFoundPage;
